
import * as handlebars_family from "../handlebars_family.ts";

const TPL = handlebars_family.addTemplate("list/tasklist-empty",{"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<flexcenter class=\"V4 flexauto flexcol\" style=\"max-width: 280px;margin: auto;text-align:center;height: 100%;\"><img src=\"/images/ic_empty_list.svg\" width=\"120\" height=\"120\"/><h1>"
    + ((stack1 = lookupProperty(helpers,"i18n").call(depth0 != null ? depth0 : (container.nullContext || {}),"catsystem.nolisttitle",{"name":"i18n","hash":{},"data":data,"loc":{"start":{"line":1,"column":177},"end":{"line":1,"column":211}}})) != null ? stack1 : "")
    + "</h1><p class=\"blockmargin sub2\">"
    + ((stack1 = lookupProperty(helpers,"i18n").call(depth0 != null ? depth0 : (container.nullContext || {}),"catsystem.nolistmessage",{"name":"i18n","hash":{},"data":data,"loc":{"start":{"line":1,"column":244},"end":{"line":1,"column":280}}})) != null ? stack1 : "")
    + "</p><button data-fw-onclick=\"listcreate\">"
    + container.escapeExpression(lookupProperty(helpers,"i18n").call(depth0 != null ? depth0 : (container.nullContext || {}),"catsystem.create",{"name":"i18n","hash":{},"data":data,"loc":{"start":{"line":1,"column":321},"end":{"line":1,"column":348}}}))
    + "</button></flexcenter>";
},"useData":true});
export default TPL;